'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckCircle2 } from 'lucide-react';
import Button from '../../common/Button';
export type SentResult = {
  kind: 'email';
  email: string;
  isNewUser: boolean;
} | {
  kind: 'username';
  username: string;
};
type Props = {
  sent: SentResult;
  onClose: () => void;
  onInviteAnother: () => void;
};
const InviteSentView = t0 => {
  const $ = _c(18);
  const {
    sent,
    onClose,
    onInviteAnother
  } = t0;
  const title = sent.kind === "email" ? `Invite sent to ${sent.email}` : `Invited @${sent.username}`;
  const body = sent.kind === "email" ? sent.isNewUser ? "A private account was created for them. The email contains a link to finish set-up and join the space." : "They'll receive an email with a link to join the space. They'll also see the invite next time they sign in." : "They'll see the invite in-app and can accept from the space page.";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CheckCircle2 size={36} className="text-primary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <p className="text-base font-emphasis text-textPrimary">{title}</p>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== body) {
    t3 = <p className="text-sm text-textSecondary/70">{body}</p>;
    $[3] = body;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-col items-center gap-3 py-4 text-center">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClose) {
    t5 = <Button text="Done" variant="SECONDARY" onClick={onClose} />;
    $[8] = onClose;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onInviteAnother) {
    t6 = <Button text="Invite another" onClick={onInviteAnother} />;
    $[10] = onInviteAnother;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex justify-end gap-2 pt-2">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <div className="space-y-3">{t4}{t7}</div>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default InviteSentView;